  <div class="buttons">
        <p class="link" *ngIf="editing || json_original !=null " (click)="recover()">Recuperar Original</p>
        <div class="spacer"></div>
        <button nz-button nzType="primary" (click)="submit()">Salvar</button>
        <button nz-button nzType="default" (click)="cancel()">Cancelar</button>
  </div>
  <nz-divider class="buttons-divider"></nz-divider>
  <nz-spin [nzSpinning]="loading" class="main-spin">
  <div class="main">
    <ng-container  [ngTemplateOutlet]="tree" [ngTemplateOutletContext]="{$implicit:data, parent:{}, count:0, deep:0}">
    </ng-container>
  </div>
  </nz-spin>


    <ng-template  #tree let-list let-parent='parent' let-count='count' let-deep='deep'>

        <form class="example-form" >
            <div *ngFor="let item of list; let i = index;" >
                <div>
                    <div *ngIf="(item.type == 'object' || item.type=='array' || item.type=='main') && !isNumber(item.name)" [ngClass]="{'titleArray':item.type=='array' && deep > 1, 'title':item.type!='array' || (item.type=='array' && deep <= 1)}">{{item.name}}</div>

                    <div *ngIf="(item.type == 'object' || item.type=='array' || item.type=='main') && isNumber(item.name)" [ngClass]="{'titleArray':true}">{{parent.name}}[{{item.name}}]</div>

                    <nz-divider class="section-divider" *ngIf="item.type == 'object' || item.type=='array' || item.type=='main'"></nz-divider>


                    <div *ngIf="parent !=undefined && parent.child !=undefined && isNumber(parent.name) && i==0"   class="arrayTitle"></div>

                        <ng-container>
                            <div [ngClass]="{'bodyArray': parent !=undefined && parent.child !=undefined && isNumber(parent.name) && item.type!='array'}"  id='s'>

                                <div class="tem-field full-width" *ngIf="item.type == 'string' || item.type == 'null'">
                                    <label class="tem-field-label">{{item.name}}</label>
                                    <input nz-input [placeholder]="item.name" [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}" (ngModelChange)="editing=true">
                                </div>

                                <div class="tem-field full-width" *ngIf="item.type == 'number'">
                                    <label class="tem-field-label">{{item.name}}</label>
                                    <input nz-input [placeholder]="item.name" [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}" type="number" (ngModelChange)="editing=true">
                                </div>

                                <div class="tem-field full-width" *ngIf="item.type == 'boolean'">
                                    <label class="tem-field-label">{{item.name}}</label>
                                    <nz-select [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}" (ngModelChange)="editing=true">
                                        <nz-option *ngFor="let tipo of [true,false]" [nzValue]="tipo" [nzLabel]="tipo?'Verdadeiro':'Falso'"></nz-option>
                                    </nz-select>
                                </div>

                            </div>
                        </ng-container>


                    <div *ngIf="item.child.length > 0" [ngClass]="{'bodyArray': parent !=undefined && parent.child !=undefined && isNumber(parent.name)}" >
                    <ng-container  [ngTemplateOutlet]="tree" [ngTemplateOutletContext]="{$implicit:item.child, parent:item, count: isNumber(item.name)? item.child.length : count, deep: deep + 1 }">
                    </ng-container>
                    </div>
                    <div *ngIf="parent !=undefined && parent.child !=undefined && isNumber(parent.name) && count==i+1"   class="arrayBottom"></div>
                </div>


            </div>
        </form>
    </ng-template>
